import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelChangesTitle: {
        id: 'tdic.endorsement.bop.directives.templates.Cancel this change ?',
        defaultMessage: 'Cancel this Change ?'
    },
    cancelMessage: {
        id: 'tdic.endorsement.bop.directives.templates.Click cancel change',
        defaultMessage: 'Click Cancel Change to stop without submitting this change.\nClick Back and Continue to continue with your change request.'
    },
    cancelChange: {
        id: 'tdic.endorsement.bop.directives.templates.Cancel Change',
        defaultMessage: 'Cancel Change'
    },
    backAndContinue: {
        id: 'tdic.endorsement.bop.directives.templates.Back and Continue',
        defaultMessage: 'Back and Continue'
    }
});
